import { useEffect } from 'react';

export const GooglePublisherTags = ({ shouldRenderPostHydration = false }: { shouldRenderPostHydration?: boolean }) => {
  useEffect(() => {
    if (!shouldRenderPostHydration) return;

    const timer = setTimeout(() => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      document.head.appendChild(script);
    }, 100);

    return () => clearTimeout(timer);
  }, [shouldRenderPostHydration]);

  if (shouldRenderPostHydration) {
    return null;
  }

  return <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" />;
};
